<template>
  <CModal title="Thông tin trả lời phản ánh kiến nghị" :show.sync="isShowPopup">
    <CRow class="content-fade-in">
      <CCol md="12">
        <CForm class="form-basic">
          <CRow>
            <CCol sm="12" md="12" xl="12">
              <div class="form-input-wrapper">
                <div class="form-group">
                  <label class="form-label">Tài khoản người trả lời</label>
                  <CInput v-model="item.responseUserName" disabled></CInput>
                </div>
              </div>
            </CCol>
            <CCol sm="12" md="12" xl="12">
              <div class="form-input-wrapper">
                <div class="form-group">
                  <label class="form-label">Họ tên người trả lời</label>
                  <CInput v-model="item.responseUserFullName" disabled></CInput>
                </div>
              </div>
            </CCol>
            <CCol sm="12" md="12" xl="12">
              <div class="form-input-wrapper">
                <div class="form-group">
                  <label class="form-label">Ngày trả lời</label>
                  <CInput v-model="item.responseDate" disabled></CInput>
                </div>
              </div>
            </CCol>
            <CCol sm="12" md="12" xl="12">
              <div class="form-input-wrapper">
                <div class="form-group">
                  <label class="form-label">Tệp đính kèm:</label>&nbsp;
                  <span>(</span>
                  <span class="view-file" v-if="item.responseFileUrl" @click="viewFile(item.responseFileUrl)">Ấn vào để xem tệp</span>
                  <span>)</span>
                </div>
              </div>
            </CCol>
            <CCol sm="12" md="12" xl="12">
              <div class="form-input-wrapper">
                <div class="form-group">
                  <label class="form-label">Nội dung trả lời</label>
                  <CTextarea v-model="item.responseDescription" readonly></CTextarea>
                </div>
              </div>
            </CCol>
          </CRow>
          <BaseLoading :loading="loading.value"></BaseLoading>
        </CForm>
      </CCol>
    </CRow>

    <template v-slot:footer>
      <div slot="footer">


      </div>
    </template>
  </CModal>
</template>
<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import BaseTextArea from "../base/BaseTextArea.vue";

export default {
  props: ["actionTypeMapping"],
  components: {BaseInput, BaseSelect, BaseLoading, BaseTextArea},
  data() {
    return {
      isShowPopup: false,
      actionTypeKey: '',
      loading: {value: false},
      item: {}
    };

  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    }
  },
  methods: {
    setCurrAction: function (key) {
      this.actionTypeKey = key;
    },
    setItem: function (item) {
      this.item = item;
      if (item.responseDate) {
        this.item.responseDate = this.$helper.formatDateDDMMYYYYHHMM(item.responseDate);
      }
    },
    async viewFile(url) {
      let that = this;
      this.loading.value = true;
      const data = await this.$helper.blobFileByUrl(url);
      that.loading.value = false;
      window.open(data)
      // window.open(this.$helper.viewFileByUrl(url))
    },
  },
  created() {
  },
  mounted() {
  },
  updated() {
  },
  computed: {},
  watch: {
    actionTypeKey: function (newValue) {
      if (newValue) {
        this.isShowPopup = true;
      }
    },
    isShowPopup: function (newValue) {
      if (!newValue) {
        this.actionTypeKey = null;
      }
    }
  }
};
</script>
<style scoped></style>
